// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Y+F0s","label":"Button_label__i1oxF"};